/** Nav/auth/dashboard strings for languages missing full TRANSLATIONS trees. */

import { buildLoginCredentialLabels } from "./credentialUiLabels";

const mk = (login, sidebar, subheader, dashboard) => ({ login, sidebar, subheader, dashboard });

export const NAV_LOCALE_BLOCKS = {
  pa: mk(
    {
      welcomeBack: "ਵਾਪਸੀ ਤੇ ਸਵਾਗਤ",
      signInContinue: "myTara ਜਾਰੀ ਰੱਖਣ ਲਈ ਸਾਈਨ ਇਨ ਕਰੋ।",
      continueGoogle: "Google ਨਾਲ ਜਾਰੀ ਰੱਖੋ",
      continueEmail: "ਈਮੇਲ ਨਾਲ ਜਾਰੀ ਰੱਖੋ",
      continuePhone: "ਫੋਨ ਨੰਬਰ ਨਾਲ ਜਾਰੀ ਰੱਖੋ",
      or: "ਜਾਂ",
      emailOrMemberId: "ਈਮੇਲ ਜਾਂ ਮੈਂਬਰ ਆਈਡੀ*",
      ...buildLoginCredentialLabels({
        field: "ਪਾਸਵਰਡ*",
        reset: "ਪਾਸਵਰਡ ਰੀਸੈਟ?",
      }),
      rememberMe: "ਮੈਨੂੰ ਯਾਦ ਰੱਖੋ",
      loginLoading: "ਲਾਗਇਨ...",
      signIn: "ਸਾਈਨ ਇਨ",
      noAccount: "ਖਾਤਾ ਨਹੀਂ ਹੈ?",
      createAccount: "ਖਾਤਾ ਬਣਾਓ",
      dataSecure: "ਤੁਹਾਡਾ ਡੇਟਾ ਸੁਰੱਖਿਅਤ ਹੈ",
    },
    {
      dashboard: "ਡੈਸ਼ਬੋਰਡ",
      familySearch: "ਪਰਿਵਾਰ ਖੋਜ",
      calendar: "ਕੈਲੰਡਰ",
      reports: "ਰਿਪੋਰਟਾਂ",
      medicalReports: "ਮੈਡੀਕਲ ਰਿਪੋਰਟਾਂ",
      myTaraReports: "ਮਾਈਤਾਰਾ ਰਿਪੋਰਟਾਂ",
      vitalsReports: "ਵਾਇਟਲ ਰਿਪੋਰਟਾਂ",
      medication: "ਦਵਾਈ",
      medCloud: "ਮੈਡਕਲਾਉਡ",
      files: "ਫਾਈਲਾਂ",
      allRightsReserved: "ਸਾਰੇ ਹੱਕ ਸੁਰੱਖਿਅਤ",
    },
    {
      rewardsProgress: "ਇਨਾਮ ਅਤੇ ਪ੍ਰਗਤੀ",
      rewardsSubtitle: "ਹਰ ਲਾਗਇਨ ਤੇ +1 ਸਿੱਕਾ · ਹੋਰ ਕਮਾਉਣ ਲਈ ਕੰਮ ਪੂਰੇ ਕਰੋ",
      balance: "ਬੈਲੇਂਸ",
      redeem: "ਰਿਡੀਮ",
      openCoinWallet: "ਇਨਾਮ ਅਤੇ ਸਿੱਕਾ ਵਾਲਿਟ ਖੋਲ੍ਹੋ",
    },
    {
      welcomeBack: "ਵਾਪਸੀ ਤੇ ਸਵਾਗਤ,",
      healthStatsToday: "ਅੱਜ ਤੁਹਾਡੇ ਸਿਹਤ ਅੰਕੜਿਆਂ ਬਾਰੇ ਜਾਣੋ।",
      heartRate: "ਦਿਲ ਦੀ ਧੜਕਣ",
      glucose: "ਗਲੂਕੋਜ਼ ਪੱਧਰ",
      oxygen: "ਆਕਸੀਜਨ",
      noData: "ਡੇਟਾ ਉਪਲਬਧ ਨਹੀਂ",
      weeklyMedicineSchedule: "ਹਫ਼ਤਾਵਾਰੀ ਦਵਾਈ ਸ਼ੈਡਿਊਲ",
      markAsTaken: "ਲਿਆ ਹੋਇਆ ਚਿਹਨਿਤ ਕਰੋ",
      taken: "ਲਿਆ ਹੋਇਆ",
      futureMedication: "ਦਵਾ ਭਵਿੱਖ ਲਈ ਨਿਰਧਾਰਤ ਹੈ।",
      details: "ਵਿਵਰਣ",
      noMedicines: "ਕੋਈ ਦਵਾ ਨਿਰਧਾਰਤ ਨਹੀਂ",
      notifications: "ਸੂਚਨਾਵਾਂ",
      noNotifications: "ਕੋਈ ਸੂਚਨਾ ਨਹੀਂ",
      markMedicationTitle: "ਦਵਾ ਲਈ ਚਿਹਨਿਤ ਕਰੋ?",
      confirmMedicationIntake: "ਦਵਾ ਸੇਵਨ ਦੀ ਪੁਸ਼ਟੀ",
      medication: "ਦਵਾਈ",
      time: "ਸਮਾਂ",
      helperText: "ਕੀ ਤੁਸੀਂ ਇਸ ਦਵਾ ਨੂੰ ਲਿਆ ਹੋਇਆ ਚਿਹਨਿਤ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
      yesMarkTaken: "ਹਾਂ, ਚਿਹਨਿਤ ਕਰੋ",
      cancel: "ਰੱਦ ਕਰੋ",
    }
  ),
  te: mk(
    {
      welcomeBack: "మళ్లీ స్వాగతం",
      signInContinue: "myTara కొనసాగించడానికి సైన్ ఇన్ చేయండి.",
      continueGoogle: "Google తో కొనసాగించండి",
      continueEmail: "ఇమెయిల్ తో కొనసాగించండి",
      continuePhone: "ఫోన్ నంబర్ తో కొనసాగించండి",
      or: "లేదా",
      emailOrMemberId: "ఇమెయిల్ లేదా మెంబర్ ఐడి*",
      ...buildLoginCredentialLabels({
        field: "పాస్‌వర్డ్*",
        reset: "పాస్‌వర్డ్ రీసెట్?",
      }),
      rememberMe: "నన్ను గుర్తుంచుకో",
      loginLoading: "లాగిన్...",
      signIn: "సైన్ ఇన్",
      noAccount: "ఖాతా లేదా?",
      createAccount: "ఖాతా సృష్టించండి",
      dataSecure: "మీ డేటా సురక్షితం",
    },
    {
      dashboard: "డాష్‌బోర్డ్",
      familySearch: "కుటుంబ శోధన",
      calendar: "క్యాలెండర్",
      reports: "రిపోర్ట్లు",
      medicalReports: "మెడికల్ రిపోర్ట్లు",
      myTaraReports: "మైతారా రిపోర్ట్లు",
      vitalsReports: "వైటల్ రిపోర్ట్లు",
      medication: "మందు",
      medCloud: "మెడ్‌క్లౌడ్",
      files: "ఫైళ్లు",
      allRightsReserved: "అన్ని హక్కులు రక్షించబడ్డాయి",
    },
    {
      rewardsProgress: "రివార్డ్స్ & పురోగతి",
      rewardsSubtitle: "ప్రతి లాగిన్‌కు +1 నాణెం",
      balance: "బ్యాలెన్స్",
      redeem: "రిడీమ్",
      openCoinWallet: "రివార్డ్స్ & కాయిన్ వాలెట్ తెరవండి",
    },
    {
      welcomeBack: "మళ్లీ స్వాగతం,",
      healthStatsToday: "ఈరోజు మీ ఆరోగ్య గణాంకాలు.",
      heartRate: "గుండె చప్పుడు",
      glucose: "గ్లూకోజ్ స్థాయి",
      oxygen: "ఆక్సిజన్",
      noData: "డేటా లేదు",
      weeklyMedicineSchedule: "వారపు మందు షెడ్యూల్",
      markAsTaken: "తీసుకున్నట్లు గుర్తించండి",
      taken: "తీసుకున్నారు",
      futureMedication: "భవిష్యత్తులో షెడ్యూల్ చేయబడింది.",
      details: "వివరాలు",
      noMedicines: "మందులు లేవు",
      notifications: "నోటిఫికేషన్లు",
      noNotifications: "నోటిఫికేషన్లు లేవు",
      markMedicationTitle: "మందు తీసుకున్నట్లు గుర్తించాలా?",
      confirmMedicationIntake: "మందు సేవన నిర్ధారించండి",
      medication: "మందు",
      time: "సమయం",
      helperText: "మీరు ఈ మందును తీసుకున్నట్లు గుర్తించాలనుకుంటున్నారా?",
      yesMarkTaken: "అవును, గుర్తించండి",
      cancel: "రద్దు",
    }
  ),
  ta: mk(
    {
      welcomeBack: "மீண்டும் வரவேற்கிறோம்",
      signInContinue: "myTara தொடர உள்நுழையவும்.",
      continueGoogle: "Google உடன் தொடரவும்",
      continueEmail: "மின்னஞ்சலுடன் தொடரவும்",
      continuePhone: "தொலைபேசி எண்ணுடன் தொடரவும்",
      or: "அல்லது",
      emailOrMemberId: "மின்னஞ்சல் அல்லது உறுப்பினர் ஐடி*",
      ...buildLoginCredentialLabels({
        field: "கடவுச்சொல்*",
        reset: "கடவுச்சொல் மீட்டமை?",
      }),
      rememberMe: "என்னை நினைவில் கொள்",
      loginLoading: "உள்நுழைவு...",
      signIn: "உள்நுழை",
      noAccount: "கணக்கு இல்லையா?",
      createAccount: "கணக்கு உருவாக்கவும்",
      dataSecure: "உங்கள் தரவு பாதுகாப்பானது",
    },
    {
      dashboard: "டாஷ்போர்டு",
      familySearch: "குடும்ப தேடல்",
      calendar: "நாட்காட்டி",
      reports: "அறிக்கைகள்",
      medicalReports: "மருத்துவ அறிக்கைகள்",
      myTaraReports: "மைதாரா அறிக்கைகள்",
      vitalsReports: "வைட்டல் அறிக்கைகள்",
      medication: "மருந்து",
      medCloud: "மெட்கிளவுட்",
      files: "கோப்புகள்",
      allRightsReserved: "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை",
    },
    {
      rewardsProgress: "வெகுமதிகள் & முன்னேற்றம்",
      rewardsSubtitle: "ஒவ்வொரு உள்நுழைவுக்கும் +1 நாணயம்",
      balance: "இருப்பு",
      redeem: "மீட்டெடு",
      openCoinWallet: "வெகுமதிகள் & நாணய பணப்பையைத் திற",
    },
    {
      welcomeBack: "மீண்டும் வரவேற்கிறோம்,",
      healthStatsToday: "இன்றைய உடல்நல புள்ளிவிவரங்கள்.",
      heartRate: "இதய துடிப்பு",
      glucose: "குளுக்கோஸ் அளவு",
      oxygen: "ஆக்ஸிஜன்",
      noData: "தரவு இல்லை",
      weeklyMedicineSchedule: "வாராந்திர மருந்து அட்டவணை",
      markAsTaken: "எடுத்ததாகக் குறி",
      taken: "எடுத்துக்கொண்டது",
      futureMedication: "எதிர்காலத்திற்கு திட்டமிடப்பட்டது.",
      details: "விவரங்கள்",
      noMedicines: "மருந்துகள் இல்லை",
      notifications: "அறிவிப்புகள்",
      noNotifications: "அறிவிப்புகள் இல்லை",
      markMedicationTitle: "மருந்து எடுத்ததாகக் குறிக்கவா?",
      confirmMedicationIntake: "மருந்து உட்கொள்ளல் உறுதிப்படுத்தல்",
      medication: "மருந்து",
      time: "நேரம்",
      helperText: "இந்த மருந்தை எடுத்ததாகக் குறிக்க விரும்புகிறீர்களா?",
      yesMarkTaken: "ஆம், குறிக்கவும்",
      cancel: "ரத்து",
    }
  ),
  mr: mk(
    {
      welcomeBack: "पुन्हा स्वागत",
      signInContinue: "myTara सुरू ठेवण्यासाठी साइन इन करा.",
      continueGoogle: "Google सह सुरू ठेवा",
      continueEmail: "ईमेलसह सुरू ठेवा",
      continuePhone: "फोन नंबरसह सुरू ठेवा",
      or: "किंवा",
      emailOrMemberId: "ईमेल किंवा सदस्य आयडी*",
      ...buildLoginCredentialLabels({
        field: "पासवर्ड*",
        reset: "पासवर्ड रीसेट?",
      }),
      rememberMe: "मला लक्षात ठेवा",
      loginLoading: "लॉगिन...",
      signIn: "साइन इन",
      noAccount: "खाते नाही?",
      createAccount: "खाते तयार करा",
      dataSecure: "तुमचा डेटा सुरक्षित आहे",
    },
    {
      dashboard: "डॅशबोर्ड",
      familySearch: "कुटुंब शोध",
      calendar: "कॅलेंडर",
      reports: "अहवाल",
      medicalReports: "वैद्यकीय अहवाल",
      myTaraReports: "मायतारा अहवाल",
      vitalsReports: "व्हायटल अहवाल",
      medication: "औषध",
      medCloud: "मेडक्लाउड",
      files: "फाइल्स",
      allRightsReserved: "सर्व हक्क राखीव",
    },
    {
      rewardsProgress: "बक्षीस आणि प्रगती",
      rewardsSubtitle: "प्रत्येक लॉगिनवर +1 नाणे",
      balance: "शिल्लक",
      redeem: "रिडीम",
      openCoinWallet: "बक्षीस आणि कॉइन वॉलेट उघडा",
    },
    {
      welcomeBack: "पुन्हा स्वागत,",
      healthStatsToday: "आजचे आरोग्य आकडेवारी.",
      heartRate: "हृदयगती",
      glucose: "ग्लुकोज पातळी",
      oxygen: "ऑक्सिजन",
      noData: "डेटा उपलब्ध नाही",
      weeklyMedicineSchedule: "साप्ताहिक औषध वेळापत्रक",
      markAsTaken: "घेतले म्हणून चिन्हांकित करा",
      taken: "घेतले",
      futureMedication: "भविष्यात नियोजित.",
      details: "तपशील",
      noMedicines: "औषधे नाहीत",
      notifications: "सूचना",
      noNotifications: "सूचना नाहीत",
      markMedicationTitle: "औषध घेतले म्हणून चिन्हांकित करायचे?",
      confirmMedicationIntake: "औषध सेवन पुष्टी",
      medication: "औषध",
      time: "वेळ",
      helperText: "हे औषध घेतले म्हणून चिन्हांकित करायचे?",
      yesMarkTaken: "होय, चिन्हांकित करा",
      cancel: "रद्द",
    }
  ),
  bn: mk(
    {
      welcomeBack: "আবার স্বাগতম",
      signInContinue: "myTara চালিয়ে যেতে সাইন ইন করুন।",
      continueGoogle: "Google দিয়ে চালিয়ে যান",
      continueEmail: "ইমেইল দিয়ে চালিয়ে যান",
      continuePhone: "ফোন নম্বর দিয়ে চালিয়ে যান",
      or: "অথবা",
      emailOrMemberId: "ইমেইল বা সদস্য আইডি*",
      ...buildLoginCredentialLabels({
        field: "পাসওয়ার্ড*",
        reset: "পাসওয়ার্ড রিসেট?",
      }),
      rememberMe: "আমাকে মনে রাখুন",
      loginLoading: "লগইন...",
      signIn: "সাইন ইন",
      noAccount: "অ্যাকাউন্ট নেই?",
      createAccount: "অ্যাকাউন্ট তৈরি করুন",
      dataSecure: "আপনার ডেটা নিরাপদ",
    },
    {
      dashboard: "ড্যাশবোর্ড",
      familySearch: "পরিবার অনুসন্ধান",
      calendar: "ক্যালেন্ডার",
      reports: "রিপোর্ট",
      medicalReports: "মেডিকেল রিপোর্ট",
      myTaraReports: "মাইতারা রিপোর্ট",
      vitalsReports: "ভাইটাল রিপোর্ট",
      medication: "ওষুধ",
      medCloud: "মেডক্লাউড",
      files: "ফাইল",
      allRightsReserved: "সর্বস্বত্ব সংরক্ষিত",
    },
    {
      rewardsProgress: "পুরস্কার ও অগ্রগতি",
      rewardsSubtitle: "প্রতিটি লগইনে +1 কয়েন",
      balance: "ব্যালেন্স",
      redeem: "রিডিম",
      openCoinWallet: "পুরস্কার ও কয়েন ওয়ালেট খুলুন",
    },
    {
      welcomeBack: "আবার স্বাগতম,",
      healthStatsToday: "আজকের স্বাস্থ্য পরিসংখ্যান।",
      heartRate: "হৃদস্পন্দন",
      glucose: "গ্লুকোজ স্তর",
      oxygen: "অক্সিজেন",
      noData: "ডেটা নেই",
      weeklyMedicineSchedule: "সাপ্তাহিক ওষুধের সময়সূচী",
      markAsTaken: "নেওয়া হিসেবে চিহ্নিত",
      taken: "নেওয়া হয়েছে",
      futureMedication: "ভবিষ্যতে নির্ধারিত।",
      details: "বিবরণ",
      noMedicines: "কোনো ওষুধ নেই",
      notifications: "নোটিফিকেশন",
      noNotifications: "কোনো নোটিফিকেশন নেই",
      markMedicationTitle: "ওষুধ নেওয়া চিহ্নিত করবেন?",
      confirmMedicationIntake: "ওষুধ গ্রহণ নিশ্চিত করুন",
      medication: "ওষুধ",
      time: "সময়",
      helperText: "এই ওষুধ নেওয়া হিসেবে চিহ্নিত করতে চান?",
      yesMarkTaken: "হ্যাঁ, চিহ্নিত করুন",
      cancel: "বাতিল",
    }
  ),
  kn: mk(
    {
      welcomeBack: "ಮತ್ತೆ ಸ್ವಾಗತ",
      signInContinue: "myTara ಮುಂದುವರಿಸಲು ಸೈನ್ ಇನ್ ಮಾಡಿ.",
      continueGoogle: "Google ನೊಂದಿಗೆ ಮುಂದುವರಿಸಿ",
      continueEmail: "ಇಮೇಲ್ ನೊಂದಿಗೆ ಮುಂದುವರಿಸಿ",
      continuePhone: "ಫೋನ್ ಸಂಖ್ಯೆಯೊಂದಿಗೆ ಮುಂದುವರಿಸಿ",
      or: "ಅಥವಾ",
      emailOrMemberId: "ಇಮೇಲ್ ಅಥವಾ ಸದಸ್ಯ ಐಡಿ*",
      ...buildLoginCredentialLabels({
        field: "ಪಾಸ್‌ವರ್ಡ್*",
        reset: "ಪಾಸ್‌ವರ್ಡ್ ರೀಸೆಟ್?",
      }),
      rememberMe: "ನನ್ನನ್ನು ನೆನಪಿಡಿ",
      loginLoading: "ಲಾಗಿನ್...",
      signIn: "ಸೈನ್ ಇನ್",
      noAccount: "ಖಾತೆ ಇಲ್ಲವೇ?",
      createAccount: "ಖಾತೆ ರಚಿಸಿ",
      dataSecure: "ನಿಮ್ಮ ಡೇಟಾ ಸುರಕ್ಷಿತ",
    },
    {
      dashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
      familySearch: "ಕುಟುಂಬ ಹುಡುಕಾಟ",
      calendar: "ಕ್ಯಾಲೆಂಡರ್",
      reports: "ವರದಿಗಳು",
      medicalReports: "ವೈದ್ಯಕೀಯ ವರದಿಗಳು",
      myTaraReports: "ಮೈತಾರಾ ವರದಿಗಳು",
      vitalsReports: "ವೈಟಲ್ ವರದಿಗಳು",
      medication: "ಔಷಧಿ",
      medCloud: "ಮೆಡ್‌ಕ್ಲೌಡ್",
      files: "ಫೈಲ್‌ಗಳು",
      allRightsReserved: "ಎಲ್ಲಾ ಹಕ್ಕುಗಳು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ",
    },
    {
      rewardsProgress: "ಬಹುಮಾನಗಳು ಮತ್ತು ಪ್ರಗತಿ",
      rewardsSubtitle: "ಪ್ರತಿ ಲಾಗಿನ್‌ಗೆ +1 ನಾಣ್ಯ",
      balance: "ಬ್ಯಾಲೆನ್ಸ್",
      redeem: "ರಿಡೀಮ್",
      openCoinWallet: "ಬಹುಮಾನಗಳು ಮತ್ತು ನಾಣ್ಯ ವಾಲೆಟ್ ತೆರೆಯಿರಿ",
    },
    {
      welcomeBack: "ಮತ್ತೆ ಸ್ವಾಗತ,",
      healthStatsToday: "ಇಂದಿನ ಆರೋಗ್ಯ ಅಂಕಿಅಂಶಗಳು.",
      heartRate: "ಹೃದಯ ಬಡಿತ",
      glucose: "ಗ್ಲೂಕೋಸ್ ಮಟ್ಟ",
      oxygen: "ಆಮ್ಲಜನಕ",
      noData: "ಡೇಟಾ ಇಲ್ಲ",
      weeklyMedicineSchedule: "ವಾರದ ಔಷಧಿ ವೇಳಾಪಟ್ಟಿ",
      markAsTaken: "ತೆಗೆದುಕೊಂಡಂತೆ ಗುರುತಿಸಿ",
      taken: "ತೆಗೆದುಕೊಂಡಿದೆ",
      futureMedication: "ಭವಿಷ್ಯದಲ್ಲಿ ನಿಗದಿ.",
      details: "ವಿವರಗಳು",
      noMedicines: "ಔಷಧಿಗಳಿಲ್ಲ",
      notifications: "ಅಧಿಸೂಚನೆಗಳು",
      noNotifications: "ಅಧಿಸೂಚನೆಗಳಿಲ್ಲ",
      markMedicationTitle: "ಔಷಧಿ ತೆಗೆದುಕೊಂಡಂತೆ ಗುರುತಿಸುವುದೇ?",
      confirmMedicationIntake: "ಔಷಧಿ ಸೇವನೆ ದೃಢೀಕರಣ",
      medication: "ಔಷಧಿ",
      time: "ಸಮಯ",
      helperText: "ಈ ಔಷಧಿಯನ್ನು ತೆಗೆದುಕೊಂಡಂತೆ ಗುರುತಿಸಲು ಬಯಸುವಿರಾ?",
      yesMarkTaken: "ಹೌದು, ಗುರುತಿಸಿ",
      cancel: "ರದ್ದು",
    }
  ),
};

export const applyNavLocaleBlocks = (translations) => {
  Object.entries(NAV_LOCALE_BLOCKS).forEach(([lang, blocks]) => {
    if (!translations[lang]) return;
    Object.entries(blocks).forEach(([section, values]) => {
      translations[lang][section] = {
        ...translations[lang][section],
        ...values,
      };
    });
  });
};
